export default __webpack_public_path__ + "static/media/Pencil.9182ce2f.cur";